import { Button } from 'components';
import { useTranslations } from 'next-intl';
import { useCurrentUser } from 'providers/UserProvider/useCurrentUser';
import { MouseEvent, useEffect, useState } from 'react';

import { toaster } from 'helpers/toaster';
import { InfoHollowIcon } from 'lib/svgs/Icons';
import { useUserGenerateAccessKeys } from 'providers/IntegrationsProvider/useUserGenerateAccessKeys';
import { notifyException } from 'services/appsignal';
import { ESpansException } from 'types/ESpans';
import KeyPopup from './KeyPopup';

const TolqAPIKey = () => {
  const t = useTranslations();
  const { data: currentUser } = useCurrentUser();

  const [modalKeyPopup, setModalKeyPopup] = useState(false);

  const handleOpenKeyPopup = () => setModalKeyPopup(true);
  const handleCloseKeyPopup = () => setModalKeyPopup(false);

  const [accessSecret, setAccessSecret] = useState('');
  const [accessKey, setAccessKey] = useState('');

  const { mutateAsync: userGenerateAccessKeys } = useUserGenerateAccessKeys();

  const generateKey = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleOpenKeyPopup();

    userGenerateAccessKeys({})
      .then((data) => {
        setAccessSecret(data?.accessSecret);
        setAccessKey(data?.accessKey);
      })
      .catch((error) => {
        notifyException(error, ESpansException.IntegrationTolqAPIKeyException);
        handleCloseKeyPopup();
        toaster.error(t('messages.error.something_wrong'));
      });
  };

  useEffect(() => {
    setAccessKey(currentUser?.accessKey ?? '');
  }, [currentUser?.accessKey]);

  return (
    <div className="legacy">
      <KeyPopup
        {...{ accessSecret, accessKey, onCancel: handleCloseKeyPopup, open: modalKeyPopup }}
      />
      <Button
        colorIcon="white"
        label={
          accessKey
            ? t('integrations.tolq_api_key.key.head_regenerate')
            : t('integrations.tolq_api_key.key.head_generate')
        }
        onClick={generateKey}
        className="gap-0"
        endAdornment={
          <span className="relative w-6">
            <a
              data-tooltip-id="tolq-info-top-start"
              data-tooltip-html={t('integrations.tolq_api_key.key.tooltip')}
              data-tooltip-offset={10}
              className="absolute -left-1 -top-5"
            >
              <InfoHollowIcon className="w-10 scale-[.6] cursor-pointer" />
            </a>
          </span>
        }
      />
    </div>
  );
};

export default TolqAPIKey;
